import Loading from "@/components/Loading";
import { Donuz } from "@/donuz-js/Donuz";
// @ is an alias to /src
export default {
  name: "contct",
  components:{
    Loading
  },
  data() {
    return {
      value: "",
      code: "",
      configs: [],
      loading: true
    };
  },
  async created() {
    if(!this.ESTABELECIMENTO.habilitar_codigo_pontuavel){
      this.$route.push(this.$route.params.slug + "/");
    }
    let result = await Donuz.scoringCode.getFields(this.ESTABELECIMENTO.id);
    if (result.status == 200) {
      this.configs = result.campos;
    }
    this.loading=false
  },
  methods: {
    submit: async function(e) {
      e.preventDefault();
      let result = await Donuz.scoringCode.insertCode(
        sessionStorage.getItem(btoa("tokenCliente")),
        {
          codigo: this.code,
          valor: this.value
        },this.ESTABELECIMENTO.id
      );
      if (result.status == 200) {
        M.toast({ html: result.mensagem, classes: "green" });
      } else {
        M.toast({ html: result.mensagem, classes: "red" });
      }
    }
  }
};
